import { Component } from 'preact'
import TranslationForm from './TranslationForm'

class TranslationsEdit extends Component {
  constructor () {
    super()
    this.state = {
      showForm: false
    }
  }
  updateFormVisibility (value) {
    this.setState({ showForm: value })
  }
  render (props, state) {
    // Example:
    // ::phrase::category--message--translation--::phrase::
    let [category, message, translation] = props.translationString
      .replace(/\n/g, ' ')
      .replace(/::phrase::/g, '')
      .split('--')

    translation = state.phrase || translation

    return (
      <span>
        { translation }
        <span onClick={this.updateFormVisibility.bind(this, true)} className='js-phrase_edit-btn'>edit</span>
        {
          state.showForm &&
          <TranslationForm
            onCallback={this.updateFormVisibility.bind(this, false)}
            onUpdate={(newPhrase) => this.setState({ phrase: newPhrase })}
            category={category}
            message={message}
            translation={translation}
          />
        }
      </span>
    )
  }
}

export default TranslationsEdit
